module.exports = __webpack_public_path__ + "img/department.05b46f1d.svg";